// extracted by mini-css-extract-plugin
export default {"input":"PlotToggleButtons_input__kfJGB","button_image":"PlotToggleButtons_button_image__ymLu8","toolbar":"PlotToggleButtons_toolbar__Vxx8l"};